import URI from 'urijs'

document.addEventListener("DOMContentLoaded", () => {
  let firstElementOfPath = URI.parse(window.location.href)
                             .path
                             .split("/")
                             .filter((el) => el != null && el != "" )
                             [0];

  switch (firstElementOfPath) {
    case 'dashboard':
      document.getElementById("dashboard-nav-link").classList.add("active")
      break;
    case 'explore':
      document.getElementById("explore-nav-link").classList.add("active")
      break;
    case 'map':
      document.getElementById("map-nav-link").classList.add("active")
      break;
    case 'about':
      document.getElementById("about-nav-link").classList.add("active")
      break;
    default:
      document.getElementById("dashboard-nav-link").classList.add("active")
  }
})
